import React, {useState, useEffect, useContext, useCallback, useMemo} from 'react';
import styles from './home.module.css';
import HomeContent from './homeContent';
import useKeyPress from '../../hooks/useKeyPress';
import Xmark from '../../assets/images/alertIcon0001.png';
import ArrowRight from '../../assets/images/arrow_right_active.PNG';
import ArrowLeft from '../../assets/images/arrow_left_active.PNG';
import {useTranslation, withTranslation, Trans} from 'react-i18next';
import MenuContext from '../../context/menuContext';
import ConfigContext from '../../context/configContext';
import CommandsContext from '../../context/commandsContext';
import SensorFailed from '../setAlert/info/sensor-failed';

const Home = ({alert, info, sensorError}) => {
  const {config} = useContext(ConfigContext);
  const configKeys = useMemo(() => Object.keys(config), [config]);
  const [index, setIndex] = useState(0);
  const {
    container,
    bottom,
    bottomTextLeft,
    bottomTextRight,
    arrowLeft,
    arrowRight,
    infoAlert,
    xmark,
    sensorFailedBottom,
    sensorFailedBottomText,
  } = styles;
  const downPress = useKeyPress('ArrowDown');
  const upPress = useKeyPress('ArrowUp');
  const rightPress = useKeyPress('ArrowRight');
  const leftPress = useKeyPress('ArrowLeft');
  const {setList, setSelected, items, onShowMenu, onShowMenu2} = useContext(MenuContext);
  const {title, number, unit} = config[configKeys[index]];
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    setList(items);
    setSelected(items[0]);
  }, []);

 /* const onLeft = useCallback(() => {
     console.log("TEST");
  }, []); */

  const onUp = useCallback(() => {
    if (configKeys.length === index + 1) return;
    setIndex(index + 1);
  }, [configKeys, index]);

  const onDown = useCallback(() => {
    setIndex(index === 0 ? index : index - 1);
  }, [index]);

  useEffect(() => {
    if (!upPress) {
      return;
    }

    onUp();
  }, [upPress]);

  useEffect(() => {
    if (!downPress) {
      return;
    }

    onDown();
  }, [downPress]);

  useEffect(() => {
    if (!rightPress) {
      return;
    }
    onShowMenu(true);
  }, [rightPress]);

  useEffect(() => {
    if (!leftPress) {
       return;
    }
    onShowMenu2(true);
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands({onUp, onRight: () => onShowMenu(true), onLeft: () => onShowMenu2(true), onDown});
  }, [onUp, onDown]);

  const {t, i18n} = useTranslation();

  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className={container}>
      <HomeContent
        title={title}
        number={number}
        unit={unit}
        alert={alert}
        info={info}></HomeContent>

      <div className={bottom}>
        <img className={arrowLeft} src={ArrowLeft} alt="Left" />
        <span className={bottomTextLeft}>{t('screen.option_btn')}</span>
        <div style={{flex: 1}} />
        <span className={bottomTextRight}>{t('screen.menu_btn.title')}</span>
        <img className={arrowRight} src={ArrowRight} alt="Right" />
      </div>
    </div>
  );
};

export default Home;
